<template>
    <v-container fluid>

        <v-card-title>

            <v-row class="pr-2 pl-6">
                <div class=" mt-md-4">
                    <v-btn @click="showSummaryReport()" class="small_screen_pos"
                           target="_blank"
                           style="margin-right: 12px"
                           v-bind:class="{'active-button-table':typeTableShow===type_summary}"
                    ><v-icon>mdi-link-variant</v-icon>Summary</v-btn>

                    <v-btn @click="showCallsReport()" class="small_screen_pos"
                            target="_blank"
                           style="margin-right: 12px"
                           v-bind:class="{'active-button-table':typeTableShow===type_calls}"
                    >
                        <v-icon>mdi-link-variant</v-icon> Calls
                    </v-btn>
                    <v-btn @click="showWebInqReport()"  target="_blank" v-bind:class="{'active-button-table':typeTableShow==='webinq'}" class="small_screen_pos">
                        <v-icon>mdi-link-variant</v-icon> Web Inquires
                    </v-btn>
                </div>

                <v-col cols="12" md="3" class="d-flex justify-start justify-md-start pb-0 pt-0 mt-0 mt-md-4 small_screen_pos small-sc-pl-0">
                    <div class="small_screen_pos">
                        <WeekFilters

                                     :weeksEnd="weeksEnd"
                                     :weeks="period"
                                     @getDates="getWeeks"
                                     :disabled="loadedReportData"
                        />

                    </div>
                </v-col>

                <v-spacer></v-spacer>

                <v-col cols="7" md="3" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">



                    <div name="excel_report_download_calls" class="mt-5">

                        <div name="excel_report_download_summary" >
                            <div v-if="typeTableShow===type_summary" >
                                <vue-excel-xlsx
                                        :data="dataReportSummary4Excel"
                                        :columns="columnsDataSummary"
                                        :filename="`CallRailSummaryReport.xlsx`"
                                        :sheetname="`report`"
                                >
                                    <v-btn
                                            height="39"
                                            min-width="39px"
                                            class="ml-auto mr-5 rounded-lg pa-0 ma-0"
                                            color="white"
                                    >
                                        <ExportExcel/>
                                    </v-btn>
                                </vue-excel-xlsx>

                            </div>
                        </div>

                        <div v-if="typeTableShow==='calls'">
                            <vue-excel-xlsx
                                    :data="dataFilteredForExcel"
                                    :columns="columnsDataCalls"
                                    :filename="`CallRailReport.xlsx`"
                                    :sheetname="`report`"
                            >
                                <v-btn
                                        height="39"
                                        min-width="39px"
                                        class="ml-auto mr-5 rounded-lg pa-0 ma-0"
                                        color="white"
                                >
                                    <ExportExcel/>
                                </v-btn>
                            </vue-excel-xlsx>

                        </div>
                        <div v-if="typeTableShow==='webinq'">
                            <vue-excel-xlsx
                                    :data="dataFilterWebInqForExcel"
                                    :columns="columnsDataWebInq"
                                    :filename="`WebInqReport.xlsx`"
                                    :sheetname="`report`"
                            >
                                <v-btn
                                        height="39"
                                        min-width="39px"
                                        class="ml-auto mr-5 rounded-lg pa-0 ma-0"
                                        color="white"
                                >
                                    <ExportExcel/>
                                </v-btn>
                            </vue-excel-xlsx>

                        </div>

                    </div>

                </v-col>
            </v-row>
        </v-card-title>

        <div v-if="typeTableShow===type_calls">
            <v-hover v-model="hoverOnTable" >
                <v-card-text>

                    <v-data-table
                            :headers="headerCallsTable"
                            :items="reportCalls"

                            item-key="title"
                            class="elevation-0 table-main-container"
                            fixed-header
                            height="538"
                            :loading="loadedReportData"
                            loading-text="Loading... Please wait"
                            :page.sync="pagination.page"
                            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"

                    >

                        <template v-slot:header.count_voicemail_unanswered="{ header }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                                </template>
                                <div style="max-width: 400px">
                                    Abounded, Missed and Voicemail
                                </div>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.CustomerState="{item}">
                            <pre>{{item['CustomerState']}}</pre>

                        </template>
                        <template v-slot:item.ClientSegment="{item}">
                            <pre>{{item['ClientSegment']}}</pre>

                        </template>
                        <template v-slot:item.CampaingStub="{ item }" @click="onclick_select_company(item)">
                            <div class="d-flex" @click="onclick_select_company(item)">

                                <v-dialog  max-width="500px">
                                    <template v-slot:activator="{ on }" >
                                        <v-icon v-on="on" bottom class="flex-grow-0 flex-shrink-0" @click="onclick_select_company(item)">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <v-card>
                                        <v-data-table
                                                :headers="[
                                                 {text: 'CallId',value:'CallId'},
                                    {text: 'Company', value: 'CustomerCompany'},
                                    {text: 'Client Segment', value: 'ClientSegment'},
                                   ]"
                                                :items="CompanyPerWeek"
                                        >

                                        </v-data-table>
                                    </v-card>
                                </v-dialog>
                                <span style="text-align: center; width: 100%;">Info</span>
                            </div>
                        </template>


                    </v-data-table>

                </v-card-text>
            </v-hover>

        </div>
        <!-- SUMMARY TABLE  -->
        <div v-if="typeTableShow === type_summary">
            <v-hover v-model="hoverOnTable" >
                <v-card-text>
                    <v-data-table
                            :headers="header4Summury"
                            :items="reportDataSummary"

                            item-key="title"
                            class="elevation-0 table-main-container"
                            fixed-header
                            height="538"
                            :loading="loadedReportData"
                            loading-text="Loading... Please wait"
                            :page.sync="pagination.page"
                            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"

                    >

                        <template v-slot:header.count_voicemail_unanswered="{ header }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                                </template>
                                <div style="max-width: 400px">
                                    Abounded, Missed and Voicemail
                                </div>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.CustomerState="{item}">
                            <pre>{{item['CustomerState']}}</pre>

                        </template>
                        <template v-slot:item.ClientSegment="{item}">
                            <pre>{{item['ClientSegment']}}</pre>

                        </template>

                        <template v-slot:item.CampaingStub="{ item }" @click="onclick_select_company(item)">
                            <div class="d-flex" @click="onclick_select_company(item)">

                                <v-dialog  max-width="500px">
                                    <template v-slot:activator="{ on }" >
                                        <v-icon v-on="on" bottom class="flex-grow-0 flex-shrink-0" @click="onclick_select_company(item)">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <v-card>
                                        <v-data-table
                                                :headers="[
                                      {text: 'CallId',value:'CallId'},
                                    {text: 'Company', value: 'CustomerCompany'},
                                    {text: 'Client Segment', value: 'ClientSegment'},
                                   ]"
                                                :items="CompanyPerWeek"
                                        >

                                        </v-data-table>
                                    </v-card>
                                </v-dialog>
                                <span style="text-align: center; width: 100%;">Info</span>
                            </div>
                        </template>
                    </v-data-table>

                </v-card-text>
            </v-hover>

        </div>

        <!-- WEbinq TABLE  -->
        <div v-if="typeTableShow === 'webinq'">
            <v-hover v-model="hoverOnTable" >
                <v-card-text>

                    <v-data-table
                            :headers="header4Bing"
                            :items="reportDataWebInq"

                            item-key="title"
                            class="elevation-0 table-main-container"
                            fixed-header
                            height="538"
                            :loading="loadedReportData"
                            loading-text="Loading... Please wait"
                            :page.sync="pagination.page"
                            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"

                    >

                        <template v-slot:header.count_voicemail_unanswered="{ header }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ header.text }}
                    <v-icon small style="margin-bottom: 2px;">
                      mdi-information
                    </v-icon>
                  </span>
                                </template>
                                <div style="max-width: 400px">
                                    Abounded, Missed and Voicemail
                                </div>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.CustomerState="{item}">
                            <pre>{{item['CustomerState']}}</pre>

                        </template>
                        <template v-slot:item.ClientSegment="{item}">
                            <pre>{{item['ClientSegment']}}</pre>

                        </template>


                    </v-data-table>

                </v-card-text>
            </v-hover>

        </div>
    </v-container>

</template>


<script>
/*
import ExportExcel from "@/components/customizing/ExportExcel.vue";
import LastTimeUpdated from "@/views/LastTimeUpdated.vue";
import CustomColumns from "@/components/customizing/CustomColumns.vue";

 */

import axios from "@/api/axios-auth";
import ExportExcel from '@/components/customizing/ExportExcel' ;
import WeekFilters from '@/components/filters/WeekFilters'


export default ({
    name: "CallReailReport",
    components: {
        //CustomColumns, LastTimeUpdated, ExportExcel
        ExportExcel,WeekFilters,
    },

    data(){
        return {
            headerCallsTable: [
                {text: 'Week Date', value: 'week_date', width: '112px', class: 'black--text'},
                {text: 'General Number', value: 'call_total_count', class: 'black--text'},
                {text: 'Company', value:'CampaingStub', class:'black--text'},
                {text: 'Unique Callers', value: 'count_uniq_calls', class: 'black--text'},
                {text: 'First-time Callers', value: 'first_calls_count', class: 'black--text'},
                {text: 'Canada', value: 'count_is_canada', class: 'black--text'},

                {text: 'Client Segment', value: 'ClientSegment', class: 'black--text'},
                {text: 'States', value: 'CustomerState', class: 'black--text'},
                {text: 'Steel', value: 'count_is_steel', class: 'black--text'},
                {text: 'Wood', value: 'count_is_wood', class: 'black--text'},
                {text: 'Gypsum', value: 'count_is_gypsym', class: 'black--text'},
                {text: 'Exterior', value: 'count_is_exterior', class: 'black--text'},
                {text: 'Unanswered', value: 'count_voicemail_unanswered', class: 'black--text'},
                {text: 'Outbound Calls', value: 'count_is_outbound', class: 'black--text'},
                {text: 'FB Paint Call', value: 'count_fire_barier', class: 'black--text'},
                {text: 'FR Clear Call', value: 'count_fr_clear', class: 'black--text'},
            ],
            header4Summury:[
                {text: 'Week Date', value: 'week_date', width: '112px', class: 'black--text'},
                {text: 'General Number', value: 'call_total_count', class: 'black--text'},
                {text: 'Company', value:'CampaingStub', class:'black--text'},
                {text: 'Unique Callers', value: 'count_uniq_calls', class: 'black--text'},
                {text: 'Web Inquires', value: 'web_inq_count', class: 'black--text'},
                {text: 'First-time Callers', value: 'first_calls_count', class: 'black--text'},
                {text: 'Canada', value: 'count_is_canada', class: 'black--text'},

                {text: 'Client Segment', value: 'ClientSegment', class: 'black--text'},
                {text: 'States', value: 'CustomerState', class: 'black--text'},
                {text: 'Steel', value: 'count_is_steel', class: 'black--text'},
                {text: 'Wood', value: 'count_is_wood', class: 'black--text'},
                {text: 'Gypsum', value: 'count_is_gypsym', class: 'black--text'},
                {text: 'Exterior', value: 'count_is_exterior', class: 'black--text'},
                {text: 'Unanswered', value: 'count_voicemail_unanswered', class: 'black--text'},
                {text: 'Outbound Calls', value: 'count_is_outbound', class: 'black--text'},
                {text: 'FB Paint Call', value: 'count_fire_barier', class: 'black--text'},
                {text: 'FR Clear Call', value: 'count_fr_clear', class: 'black--text'},
            ],
            header4Bing:[
                {text: 'Week Date', value: 'week_date', width: '112px', class: 'black--text'},
                {text: 'General Number', value: 'total_count', class: 'black--text'},
                {text: 'Exterior', value: 'count_is_exterior', class: 'black--text'},
                {text: 'Gypsum', value: 'count_is_gypsym', class: 'black--text'},
                {text: 'Steel', value: 'count_is_steel', class: 'black--text'},
                {text: 'Wood', value: 'count_is_wood', class: 'black--text'},
                {text: 'FB Paint', value: 'count_fire_barier', class: 'black--text'},
                {text: 'FR Clear', value: 'count_fr_clear', class: 'black--text'},
            ],

            dataWeeks: [],
            reportDataSummary:[],
            reportDataWebInq:[],
            reportCalls:[],
            reportCallAndCompany:[],

            typeTableShow:'summary',// 'calls','webinq','summary'
            type_calls:'calls',
            type_webinq:'webinq',
            type_summary:'summary',

            CompanyPerWeek:[],

            loadedReportData:false,
            selectedHeadersMonth: [],
            pagination: {
                page: 1
            },
            hoverOnTable: false,
            columnsDataCalls:[],
            columnsDataSummary:[],
            columnsDataWebInq:[],
            weeksEnd: new Date().toISOString().substr(0, 10),
            period: '20',
        }
    },
    customSort: function(items, index, isDesc) {
        items.sort((a, b) => {
            if (index[0]=='title') {
                if (!isDesc[0]) {
                    return new Date(b[index]) - new Date(a[index]);
                } else {
                    return new Date(a[index]) - new Date(b[index]);
                }
            }
            else {
                if(typeof a[index] !== 'undefined'){
                    if (!isDesc[0]) {
                        return a[index] - b[index];
                    }
                    else {
                        return b[index] - a[index]
                    }
                }
            }
        });
        return items;
    },
    rowClick: function (item, row) {
        let selectState = (row.isSelected) ? false : true
        row.select(selectState)
    },
    mounted() {
        this.getHeaderForExcel();

        axios
            .get('/username')
            .then(response => (this.userName = response.data));
        this.loadReport();

    },
    methods:{
        loadReport:function (){
            this.loadedReportData = true;

            axios
                .get('/reports/callrail-webinq-summary-pivot-dtrange/'+ this.weeksEnd + '/' + this.period )
                .then(response=>{
                    this.reportDataSummary = response.data.data_summary;
                    this.reportCalls = response.data.data_calls;
                    this.reportDataWebInq = response.data.data_webinq;
                    this.reportCallAndCompany = response.data.call_company;

                    let call_cmp = response.data.call_campaing;
                    console.log(call_cmp)

                    for(let i in this.reportDataSummary){
                        let item = this.reportDataSummary[i]
                        if ( typeof(item['CustomerState']) != 'string' ) item['CustomerState'] = item['CustomerState'].join('\n')
                        if ( typeof(item['ClientSegment']) != 'string' ) item['ClientSegment'] = item['ClientSegment'].join('\n')

                        item['CampaingStub'] = 'Campaign';
                    }
                    for(let i in this.reportCalls){
                        let item = this.reportCalls[i]
                        if ( typeof(item['CustomerState']) != 'string' ) item['CustomerState'] = item['CustomerState'].join('\n')
                        if ( typeof(item['ClientSegment']) != 'string' ) item['ClientSegment'] = item['ClientSegment'].join('\n')
                        item['CampaingStub'] = 'Campaign';
                    }
                    this.loadedReportData = false;
                });
        },
        getHeaderForExcel() {
            let coll_names = ['week_date','call_total_count','count_uniq_calls','first_calls_count',
                'count_is_canada','count_is_steel','count_is_wood','count_is_gypsym','count_is_exterior','count_voicemail_unanswered',
                'count_is_outbound','count_fire_barier','count_fr_clear','ClientSegment','CustomerState'];
            let coll_names_summary = ['week_date','call_total_count','count_uniq_calls','web_inq_count','first_calls_count',
                'count_is_canada','count_is_steel','count_is_wood','count_is_gypsym','count_is_exterior','count_voicemail_unanswered',
                'count_is_outbound','count_fire_barier','count_fr_clear','ClientSegment','CustomerState'];

            /*
              {text: 'General Number', value: 'total_count', class: 'black--text'},
                {text: 'Exterior', value: 'count_is_exterior', class: 'black--text'},
                {text: 'Gypsum', value: 'count_is_gypsym', class: 'black--text'},
                {text: 'Steel', value: 'count_is_steel', class: 'black--text'},
                {text: 'Wood', value: 'count_is_wood', class: 'black--text'},
                {text: 'FR Clear', value: 'count_fr_clear', class: 'black--text'},
                {text: 'FR Paint', value: 'count_fire_barier', class: 'black--text'},
             */

            let coll_names_webinq = [
                'week_date','total_count','count_is_exterior','count_is_gypsym','count_is_steel'
                ,'count_is_wood','count_fr_clear','count_fire_barier'
            ];

            const mapFieldsNames = new Map();
            mapFieldsNames.set('week_date','Week Date');
            mapFieldsNames.set('call_total_count','General Number');
            mapFieldsNames.set('count_uniq_calls','Unique Callers');
            mapFieldsNames.set('first_calls_count','First-time Callers');
            mapFieldsNames.set('count_is_canada','Canada');
            mapFieldsNames.set('count_is_steel','Steel');
            mapFieldsNames.set('count_is_wood','Wood');
            mapFieldsNames.set('count_is_gypsym','Gypsym');
            mapFieldsNames.set('count_is_exterior','Exterior');
            mapFieldsNames.set('count_voicemail_unanswered','Unanswered');
            mapFieldsNames.set('count_is_outbound','Outbound Calls');
            mapFieldsNames.set('count_fire_barier','FB Paint Call');
            mapFieldsNames.set('count_fr_clear','FR Clear Call');
            mapFieldsNames.set('ClientSegment','Client Segment');
            mapFieldsNames.set('CustomerState','Customer State');

            const mapFieldsSummary = new Map(mapFieldsNames)
                //'Web Inquires', value: 'web_inq_count'
            mapFieldsSummary.set('web_inq_count','Web Inquires')

            //
            const mapFieldsNamesWebInq = new Map();
            mapFieldsNamesWebInq.set('week_date','Week Date');
            mapFieldsNamesWebInq.set('total_count','General Number');
            mapFieldsNamesWebInq.set('count_uniq_calls','Unique Callers');
            mapFieldsNamesWebInq.set('first_calls_count','First-time Callers');
            mapFieldsNamesWebInq.set('count_is_steel','Steel');
            mapFieldsNamesWebInq.set('count_is_wood','Wood');
            mapFieldsNamesWebInq.set('count_is_gypsym','Gypsym');
            mapFieldsNamesWebInq.set('count_is_exterior','Exterior');
            mapFieldsNamesWebInq.set('count_fire_barier','FB Paint Call');
            mapFieldsNamesWebInq.set('count_fr_clear','FR Clear Call');


            this.columnsDataCalls = coll_names.map(e => {
                const obj = {}
                obj.label = mapFieldsNames.get(e)
                obj.field = e
                return obj
            })
                //.filter(value => Object.keys(value).length !== 0);

            this.columnsDataWebInq = coll_names_webinq.map(e=>{
                const obj = {}
                obj.label = mapFieldsNamesWebInq.get(e)
                obj.field = e
                return obj
            });

            this.columnsDataSummary = coll_names_summary.map(e=>{
                const obj = {}
                obj.label = mapFieldsSummary.get(e)
                obj.field = e
                return obj
            }).filter(value => Object.keys(value).length !== 0);
        },

        getWeeks(dates){
            this.period = dates.period
            this.weeksEnd = dates.weeksEnd
            this.pagination.page = 1
            this.applyFiltersWeek()
        },
        showCallsReport(){
            this.typeTableShow = this.type_calls
        },
        showWebInqReport(){
            this.typeTableShow =  this.type_webinq
        },
        showSummaryReport(){
            this.typeTableShow = this.type_summary
        },

        applyFiltersWeek() {
            this.loadReport()
        },

        onclick_select_company(arg){
            // filter items ['week_num'] == arg['week_num']
            let res = []
            for(let rec of this.reportCallAndCompany){
                if ( rec['week_num'] != arg['week_num']) continue;
                res.push(rec)
            }
            this.CompanyPerWeek = res;

        },

    },
    computed: {
        dataFilteredForExcel() {
            if (!this.reportCalls) return []
            let data = JSON.parse(JSON.stringify(this.reportCalls))

            return data
        },
        dataReportSummary4Excel(){
            if (!this.reportDataSummary) return []
            let data = JSON.parse(JSON.stringify(this.reportDataSummary))
            return data

        },

        dataFilterWebInqForExcel(){
            if (!this.reportDataWebInq) return []
            let data = JSON.parse(JSON.stringify(this.reportDataWebInq))
            return data
        }

    },

})
</script>


<style scoped>

.active-button-table{
    background-color: #3f51b5!important;
    color:white;
}

@media  (max-width: 960px) {
    .small_screen_pos{
        margin-top: 0.5rem!important;
    }
    .small-sc-pl-0{
        padding-left: 0;
    }
}

</style>